import React from 'react';
import { Helmet } from 'react-helmet';
import AppMainLayout from "src/components/AppMainLayout";

export class App extends React.Component {
    render() {
        return (
            <>
                <Helmet>
                    <meta name="viewport" content="width=device-width, initial-scale=1"/>
                </Helmet>
                <AppMainLayout/>
            </>
        );
    }
}

export default App;
